import Badge from '../../../components/ui/Badge';

/**
 * Compliance status badge for a site, derived from its open-defect count.
 * Shared by the sites table, mobile cards, and the desktop summary panel.
 */
export default function SiteStatusBadge({ count, isLoading, isError }) {
  if (isLoading) return <span className="text-muted text-xs">…</span>;
  if (isError) return <span className="text-muted text-xs">—</span>;
  if (count > 0) {
    return <Badge variant="warning">{count} Repairs Due</Badge>;
  }
  return <Badge variant="success">Compliant</Badge>;
}
